import { render, staticRenderFns } from "./PlanEdit.vue?vue&type=template&id=56ef7cd0&scoped=true"
import script from "./PlanEdit.vue?vue&type=script&lang=js"
export * from "./PlanEdit.vue?vue&type=script&lang=js"
import style0 from "./PlanEdit.vue?vue&type=style&index=0&id=56ef7cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef7cd0",
  null
  
)

export default component.exports